<template>
    <div>
        <div class="address_content">
            <div class="address_content_left">
                <el-form ref="form" :model="form" label-width="100px" style="width: 100%">
                    <el-form-item label="联系人" required>
                        <el-input v-model="form.contactName"
                                  placeholder="请填写联系人"
                                  class="address_input"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" required>
                        <el-input v-model="form.phoneNumber"
                                  placeholder="请填写手机号"
                                  class="address_input"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区" required>
                        <el-select class="country-select"
                                clearable
                                filterable
                                @change="countryChange"
                                placeholder="请选择所在地区"
                                size="small"
                                v-model="form.country">
                            <el-option v-for="item in countryOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="行政区" v-show="form.country==='中国大陆'" required>
                        <el-cascader
                            :options="addressOptions"
                            @change="handleItemChange"
                            class="dialog-cascader"
                            placeholder="请选择行政区"
                            v-model="selectAddress"
                            ref="cascader"></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" v-show="form.country" required>
                        <el-input :rows="3"
                            class="address-detail"
                            placeholder="请填写详细地址"
                            type="textarea"
                            v-model.trim="form.contactAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="邮编">
                        <el-input v-model="form.postcode"
                                  placeholder="请填写邮编"
                                  class="address_input"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="address_content_right">
                <el-form style="width: 100%">
                    <el-form-item label="地址识别">
                        <template>
                            <el-input placeholder="请输入地址"
                                type="textarea"
                                :rows="3"
                                v-model.trim="identifyAddress"/>
                            <el-button type="primary"
                                       @click="identify"
                                       style="width: 100px;float: right;margin-top: 10px">识 别</el-button>
                        </template>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="address_add_footer">
            <el-button @click="close()">取 消</el-button>
            <el-button type="primary" @click="submit">确 认</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import countryJson from '../../../constant/country.json';

    export default {
        name: 'AddressAddDialog',
        data() {
            return {
                countryJson,
                countryOptions: [],
                form: {
                    contactName: '',
                    phoneNumber: '',
                    postcode: '',
                    country: '中国大陆',
                    area: '',
                    contactAddress: '',
                    province: '',
                    city: '',
                    county: '',
                    street: '',
                },
                identifyAddress: '',
                selectAddress: [],
                addressOptions: this.addressLists
            }
        },
        props: {
            addressType: {
                type: String,
                default: ''
            },
            addressLists: {
                type: Array,
                default: []
            }
        },
        mounted() {
            this.countryOptions = this.countryJson.COUNTRY.map(item => ({
                ...item,
                value: item.Chinese_name,
                label: item.Chinese_name
            }));
        },
        methods: {
            addNewProp(arr) {
                return arr.map(item => {
                    if (item.children && item.children.length > 0) {
                        return {
                            ...item,
                            value: item.name,
                            label: item.name,
                            code: item.code,
                            children: this.addNewProp(item.children).map(child => ({
                                ...child,
                            })),
                        };
                    } else {
                        return {
                            ...item,
                            value: item.name,
                            label: item.name,
                            code: item.code,
                            children: undefined
                        };
                    }
                });
            },
            close() {
                this.form = {
                    contactName: '',
                    phoneNumber: '',
                    postcode: '',
                    country: '中国大陆',
                    area: '',
                    contactAddress: '',
                    province: '',
                    city: '',
                    county: '',
                    street: '',
                },
                this.identifyAddress = '';
                this.selectAddress = [];
                this.$emit('addAddressClose', false);
            },
            submit() {
                if (!this.form.contactName) {
                    this.$message.error('请填写联系人');
                    return;
                }
                if (!this.form.phoneNumber) {
                    this.$message.error('请填写手机号');
                    return;
                }
                // if (!this.form.postcode) {
                //     this.$message.error('请填写邮编');
                //     return;
                // }
                if (!this.form.country) {
                    this.$message.error('请选择所在地区');
                    return;
                }
                if (this.form.country === '中国大陆') {
                    if (!this.form.province || !this.form.city || !this.form.county) {
                        this.$message.error('请选择行政区');
                        return;
                    }
                }
                if (!this.form.contactAddress) {
                    this.$message.error('请填写详细地址');
                    return;
                }
                this.$emit('submitAddress', { form: this.form, addressType: this.addressType });
            },
            countryChange() {
                this.form.province = '';
                this.form.city = '';
                this.form.county = '';
                this.form.street = '';
                this.form.contactAddress = '';
                this.$refs.cascader.$refs.panel.clearCheckedNodes();
                this.$refs.cascader.$refs.panel.activePath = [];
                this.$refs.cascader.$refs.panel.menus = [this.$refs.cascader.$refs.panel.menus[0]];
                this.selectAddress = [];
            },
            handleItemChange(val) {
                this.form.province = val[0];
                this.form.city = val[1];
                this.form.county = val[2];
                this.form.street = val[3];
            },
            async identify() {
                if (this.identifyAddress === '') {
                    this.$message.warning('请输入地址');
                    return;
                }
                this.$refs.cascader.$refs.panel.clearCheckedNodes();
                this.$refs.cascader.$refs.panel.activePath = [];
                this.$refs.cascader.$refs.panel.menus = [this.$refs.cascader.$refs.panel.menus[0]];
                this.selectAddress = [];
                const url = '/baiduAITokenApi?grant_type=client_credentials&client_id=i0TatNYnY4OGAVWbo1v9MXoY&client_secret=xWvmAP33F14jMs7DX9a5pVzLyaSs5zQR';
                await axios.post(url, {}, {
                    baseURL: ''
                }).then(async res => {
                    const url2 = `/baiduAIAddressApi?access_token=${res.data.access_token}`
                    await axios.post(url2, { text: this.identifyAddress }, {
                        baseURL: ''
                    }).then(response => {
                        if (response.status === 200) {
                            this.$message.success('识别成功');
                            const data = response.data;
                            this.form.country = '中国大陆';
                            this.form.contactAddress = data.detail;
                            this.form.province = data.province;
                            this.form.city = data.city;
                            this.form.county = data.county;
                            this.form.street = data.town;
                            this.selectAddress = [data.province, data.city, data.county, data.town];
                            if (data.person !== '') {
                                this.form.contactName = data.person;
                            }
                            if (data.phonenum !== '') {
                                this.form.phoneNumber = data.phonenum;
                            }
                        }
                    }).catch(error => {
                        this.$message.error('识别失败');
                        console.log(error);
                    })
                }).catch(err => {
                    this.$message.error('获取access_token失败');
                    console.log(err);
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .address_content {
        display: flex;
        align-items: flex-start;
    }
    .address_content_left {
        width: 50%;
        display: inline-flex;
        ::v-deep .el-form-item__content {
            margin-left: 30px !important;
        }
    }
    .address_content_right {
        width: 50%;
        display: inline-flex;
    }
    .address_input {
        width: 70%;
    }
    .country-select {
        width: 70%;
        ::v-deep .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }
    .dialog-cascader {
        width: 70%;
    }
    .address-detail {
        width: 70%;
        line-height: 40px;
        ::v-deep .el-textarea__inner {
            line-height: 28px;
        }
    }
    .city-choose {
        overflow: hidden;
    }
    .address_add_footer {
        display: flex;
        bottom: 20px;
        width: 100%;
        box-sizing: border-box;
        justify-content: center;
        padding-top: 20px;
        .el-button {
            width: 30%;
            height: 40px;
            font-weight: 400;
            font-size: 16px;
        }
    }
</style>